export enum SavedViewsSectionBlock {
  Root = 'SavedViewsSection',
}

export enum SavedViewsSectionModifier {
  Width = 'Width',
}
